import { Tab, Tabs } from 'react-bootstrap'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import CustomModal from 'components/CustomModal/CustomModal'
import AnalyticsAll from '../AnalyticsAll/AnalyticsAll'
import AnalyticsTracked from '../AnalyticsTracked/AnalyticsTracked'
import styles from './AnalyticsModal.module.css'
import './Analytics.css'
import analyticsTypes from '../../../enums/analytics/analyticsTypes'
import { hideAnalyticsModal } from '../../../actions'

const AnalyticsModal = ({ trialMode, onUpgradeCTA }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const payload = useSelector((state) => state.modals.analyticsModalPayload)
  const [analyticsType, setAnalyticsType] = useState(payload?.analyticsType || analyticsTypes.ANALYTICS)

  useEffect(() => {
    history.push({ pathname: '/manage/analytics' })
  }, [history])

  const onClose = () => {
    const { pathname } = window.location
    if (pathname.startsWith('/manage/analytics')) {
      history.push('/manage')
    }
    dispatch(hideAnalyticsModal())
  }

  const handleSelectTab = (key) => {
    setAnalyticsType(key)
  }

  return (
    <CustomModal
      show={true}
      size="xl"
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      enforceFocus={false}
      dialogClassName={styles.modalDialogWidth}
    >
      <div className="p-4">
        <Tabs
          activeKey={analyticsType}
          onSelect={handleSelectTab}
          id="analytics-tabs"
          className="mb-3"
          mountOnEnter
          unmountOnExit
        >
          <Tab eventKey={analyticsTypes.ANALYTICS} title="All analytics">
            <AnalyticsAll domain={payload?.site} trialMode={trialMode} onUpgradeCTA={onUpgradeCTA} />
          </Tab>
          <Tab eventKey={analyticsTypes.TRACKED} title="Tracked links">
            <AnalyticsTracked domain={payload?.site} />
          </Tab>
        </Tabs>
      </div>
    </CustomModal>
  )
}

export default AnalyticsModal
